import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisonData = [{
  without: 'Apuntes dispersos sin orden',
  with: 'Sistema organizado desde el día 1'
}, {
  without: 'Bibliografía que no podés retener',
  with: 'Resúmenes visuales listos para usar'
}, {
  without: 'Corrientes que se mezclan y confunden',
  with: 'Mapas comparativos por corriente'
}, {
  without: 'Sin guía para la primera entrevista',
  with: 'Plantilla clínica completa incluida'
}, {
  without: 'Estudiás de cero cada parcial',
  with: 'Material acumulable semestre a semestre'
}];
export function Comparison() {
  return <section className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8" data-id="element-46">
      <div className="max-w-2xl mx-auto" data-id="element-47">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-2xl font-bold text-center text-white mb-8" data-id="element-48">
          Sin PsiRecursos Pro vs. Con PsiRecursos Pro
        </motion.h2>

        <div className="bg-brand-dark rounded-2xl overflow-hidden border border-white/10" data-id="element-49">
          <div className="grid grid-cols-2 bg-white/5 border-b border-white/10" data-id="element-50">
            <div className="p-4 text-center font-semibold text-gray-400 text-sm flex items-center justify-center gap-2" data-id="element-51">
              <X className="w-4 h-4 text-red-400" data-id="element-52" /> Sin PsiRecursos Pro
            </div>
            <div className="p-4 text-center font-semibold text-white text-sm flex items-center justify-center gap-2 bg-brand-violet/10" data-id="element-53">
              <Check className="w-4 h-4 text-brand-sky" data-id="element-54" /> Con PsiRecursos Pro
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-55">
            {comparisonData.map((row, idx) => <motion.div key={idx} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="grid grid-cols-2" data-id="element-56">
                <div className="p-4 text-sm text-gray-400 flex items-center" data-id="element-57">
                  {row.without}
                </div>
                <div className="p-4 text-sm text-white font-medium bg-brand-violet/5 flex items-center" data-id="element-58">
                  {row.with}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}